<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="textarea-field-config pt-2">
		<vs-row>
			<vs-col vs-w="3" vs-xs="12">
				<vs-radio vs-name="type" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.TEXTAREA.TYPE_RAW" v-model="localValue">{{ $t("FieldConfig.BasicTextarea") }}</vs-radio>
			</vs-col>
			<vs-col vs-w="9" vs-xs="12" class="text-black">
				<vs-radio vs-name="type" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.TEXTAREA.TYPE_RICHTEXT" v-model="localValue">{{ $t("FieldConfig.AdvancedTextarea") }}</vs-radio>
			</vs-col>
		</vs-row>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	name: "TextareaFieldConfig",
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => prop.hasOwnProperty("type")
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value.type;
			},
			set(val) {
				this.$emit("input", { ...this.value, type: val });
			}
		}
	}
};
</script>
